// extracted by mini-css-extract-plugin
module.exports = {"button":"LinkButton_button___HCc9","pink":"LinkButton_pink__1GArw"};